import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomMenu from "../../../../components/Menu";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";

function EstimatedFilter({ children }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [status, setStatus] = useState('All');
  const [estimated, setEstimated] = useCustomSearchParams('estimated');
  const handleChange = (e) => {
    setEstimated("estimated", e);
  };
  return (
    <div className="search-estimated-filter d-flex align-items-center">
      {children}
      <div className="estimated-filter-menu">
        <KeyboardArrowDownIcon
          className="cursor-pointer icon"
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          }}
        />
        <CustomMenu
          anchorEl={anchorEl}
          open={!!anchorEl}
          handleClose={() => setAnchorEl(null)}
        >
          <CustomMenuItem>
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`board-list-my-task-checkbox-all-board`}
                checked={estimated === "All" || !estimated}
                onClick={(event) => {
                  event.stopPropagation();
                  handleChange('All')
                }}
              />
              <span className="checkmark"></span>
              All
            </label>
          </CustomMenuItem>
          <CustomMenuItem>
            {" "}
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`board-list-my-task-checkbox-all-board`}
                checked={estimated === "Estimated"}
                onClick={(event) => {
                  event.stopPropagation();
                  handleChange('Estimated')
                }}
              />
              <span className="checkmark"></span>
              Estimated
            </label>
          </CustomMenuItem>
          <CustomMenuItem>
            {" "}
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`board-list-my-task-checkbox-all-board`}
                checked={estimated === "Not Estimated"}
                onClick={(event) => {
                  event.stopPropagation();
                  handleChange('Not Estimated')
                }}
              />
              <span className="checkmark"></span>
              Not Estimated
            </label>
          </CustomMenuItem>
        </CustomMenu>
      </div>
    </div>
  );
}

export default EstimatedFilter;
